<template>
    <div class="page talron main-page scan-page">

        <layout-solid-blob title="talron.privacyPolicy.viewTitle" >
          <div class="ac-doc">
            <p class="uk-text-meta">עודכן לאחרונה: 19/10/2025</p>
            <p>טלרון מצברים בע"מ (להלן: "החברה") פועלת בייבוא, שיווק ומתן שירותים בתחום פתרונות אנרגיה מתקדמים. מדיניות זו מבהירה כיצד אנו אוספים, משתמשים, שומרים ומשתפים מידע אישי בהתאם לדין. מדיניות זו חלה על כל אמצעי הקשר עם החברה.</p>

            <ol class="uk-list uk-padding-right">
              <li>
                <h2>1. כללי</h2>
                <p>החברה הינה חלק מקבוצת דוד לובינסקי בע"מ. מדיניות פרטיות זו מהווה חלק מתנאי השימוש באתר החברה, ובמקרה של סתירה – עדיפות למדיניות זו.</p>
              </li>

              <li>
                <h2>2. סוג ומקור המידע הנאסף</h2>
                <p>במסגרת ההתקשרות והשימוש באתר נאסף מידע כמפורט להלן:</p>
                <ul>
                  <li><span>מידע אישי:</span> שם, טלפון, כתובת, מספר זהות/דרכון, מגדר, תאריך לידה, דוא"ל, מספר רכב/שלדה, פרטי רכישה/ליסינג ולעיתים צילום רישיון.</li>
                  <li><span>מידע עסקי:</span> שם חברה, מספר ח.פ., פרטי אנשי קשר מקצועיים ותפקידים, תחומי עיסוק ופרטי התקשרות מוסדיים.</li>
                  <li><span>העדפות שיווקיות ומשוב:</span> ניתן לסרב לשימוש למטרות שיווקיות.</li>
                  <li><span>מידע טכנולוגי:</span> כתובת IP, דפדפן, מערכת הפעלה והרגלי שימוש באתר.</li>
                  <li><span>מקורות מידע:</span> המשתמש עצמו, איסוף אוטומטי בעת שימוש באתר, ולעיתים גורמים שלישיים (סוכנויות רכב, גופי מימון, ליסינג, ביטוח), בהתאם לאופי ההתקשרות.</li>
                </ul>
                <p>מידע עשוי להישמר גם אם לא נרכשו שירותים/מוצרים.</p>
              </li>

              <li>
                <h2>3. חובת מסירה ואופן ההסכמה</h2>
                <ul>
                  <li><span>מסירת מידע היא וולונטרית</span>, אך מידע מסוים נדרש לצורך מתן שירות.</li>
                  <li>השימוש באתר מהווה אישור לכך שקראת והבנת את המדיניות.</li>
                  <li>בהיעדר הזנת פרטים מזהים, איסוף המידע יהיה סטטיסטי וכללי בלבד.</li>
                </ul>
              </li>

              <li>
                <h2>4. מטרות השימוש במידע</h2>
                <ul>
                  <li>זיהוי אישי ומתן שירות/מוצר.</li>
                  <li>ניהול התקשרויות למכירה, תמיכה והתקנות.</li>
                  <li>שירות לקוחות, טיפול בפניות ותיעוד.</li>
                  <li>שימור הקשר ושיפור חוויית המשתמש ובקרת איכות.</li>
                  <li>עמידה בדרישות חוקיות ורגולטוריות.</li>
                  <li>העברת מידע ליצרן הרכב והקבוצה במידת הצורך ועל פי דין.</li>
                  <li>טיפול בבקשות לעיון/תיקון מידע.</li>
                  <li>דיוור שיווקי (בכפוף להסכמה מפורשת).</li>
                  <li>ניהול הליכים משפטיים לפי הצורך.</li>
                </ul>
              </li>

              <li>
                <h2>5. שימוש בעוגיות וטכנולוגיות איסוף</h2>
                <p>האתר עושה שימוש ב־Cookies לצרכים טכניים (שמירת העדפות, איזון עומסים, זיהוי תנועה זדונית) ולשיפור חוויית המשתמש.</p>
                <ul>
                  <li>המידע עשוי לכלול משך ביקור, דפים נצפים, IP ומאפייני מכשיר.</li>
                  <li>חלק מהעוגיות נמחקות בסגירת הדפדפן וחלקן קבועות.</li>
                  <li>לא נעשה שימוש בכלי צד שלישי לפרסום/ניתוח סטטיסטי המבצעים איסוף מזהה.</li>
                  <li>ניתן לחסום/למחוק עוגיות בדפדפן (ייתכן פגיעה בתפקוד האתר).</li>
                </ul>
              </li>

              <li>
                <h2>6. שיתוף מידע עם צדדים שלישיים</h2>
                <ul>
                  <li>יצרן הרכב, ספקים מטעם החברה ומרכזי שירות מורשים.</li>
                  <li>רשויות מוסמכות לפי דרישה חוקית/צו.</li>
                  <li>שותפים עסקיים וספקים בתחום האנרגיה/תקשורת/תחבורה לצורך אספקת שירות.</li>
                  <li>חברות אחרות בקבוצה – לדיוור שיווקי רק בכפוף להסכמה מפורשת.</li>
                </ul>
                <p>ניתן לשתף מידע שאינו אישי/שאינו מאפשר זיהוי. החברה פועלת לוודא כי מקבלי המידע פועלים לפי דיני הגנת הפרטיות.</p>
              </li>

              <li>
                <h2>7. העברת מידע לענן ו/או חו"ל</h2>
                <p>מאגרי המידע מנוהלים על שרתים מקומיים. אין העברת מידע אישי לענן/לחו"ל.</p>
              </li>

              <li>
                <h2>8. זכויות נושאי המידע ומענה לבקשות</h2>
                <p>לנושאי המידע שמידע אישי עליהם מוחזק בידי החברה, מוקנות הזכויות הבאות, בהתאם לחוק הגנת הפרטיות (תיקון מס' 13):</p>
                <ul>
                  <li><strong>זכות לידיעה</strong> –  בעת איסוף המידע נמסר לך מי בעל השליטה במאגר, מטרות השימוש במידע, האם מסירת המידע נדרשת על פי דין או נתונה להסכמה חופשית, מהי תוצאת אי-הסכמה, ולמי עשוי המידע להימסר.</li>
                  <li><strong>זכות עיון</strong> –  זכות לקבל מאיתנו, בתוך 30 ימים קלנדריים ממועד פנייתך, מידע בדבר הנתונים האישיים שנשמרים אודותיך במאגרי החברה, לרבות סוגי המידע שנאספו, מטרות השימוש במידע, ולמי הועבר המידע אם הועבר.</li>
                  <li><strong>זכות לתיקון</strong> –  זכות לבקש שנעדכן, נתקן או נמחק מידע אישי שאינו נכון, שאינו שלם, שאינו ברור או שאינו רלוונטי, בכפוף לחובות החברה לשמור מידע מכוח כל דין. במידה והמידע נמסר לגורמים שלישיים מטעמנו, ניידע אותם על התיקון או המחיקה שבוצעו. תשובה תימסר תוך 30 ימים קלנדריים ממועד פנייתך.</li>
                  <li><strong>זכות להסרה מדיוור ישיר</strong> –  באפשרותך לדרוש בכל עת שלא נכלול את פרטיך במאגר המשמש לדיוור ישיר.</li>
                </ul>
                <p><strong>אופן מימוש הזכויות</strong> –  ניתן לפנות בבקשה למימוש זכויותיך באמצעות הקישור כאן: <a href="https://www.lubinski.co.il/privacy/?comp=12" target="_blank">מימוש זכויות נושא המידע</a>, בהתאם להנחיות המפורטות באתר.</p>
                <p>הפנייה תיבדק ותטופל בהתאם להוראות הדין, ותשובה תימסר בתוך 30 ימים קלנדריים ממועד קבלת הבקשה.</p>
                <p>במקרה של קושי טכני באתר, ניתן לפנות בדוא"ל  <a href="mailto:privacy@talronbatt.co.il">privacy@talronbatt.co.il</a> ולתאר את מהות הבקשה.</p>
              </li>

              <li>
                <h2>9. אבטחת מידע</h2>
                <p>החברה מיישמת אמצעי הגנה פיזיים, לוגיים וארגוניים, הרשאות גישה מוגבלות וניטור שוטף, ופועלת בהתאם לחוק הגנת הפרטיות והתקנות.</p>
                <p>המידע נשמר לתקופה הנדרשת למטרות האיסוף ולעמידה בדרישות הדין, תוך בחינה תקופתית של נחיצותו.</p>
                <p>העברת מידע באמצעים שאינם בשליטת החברה (כגון דוא"ל/אפליקציות מסרים) כפופה למדיניות אותם שירותים. אבטחת המידע במכשירי המשתמש הינה באחריות המשתמש.</p>
              </li>

              <li>
                <h2>10. ניהול מאגרי מידע</h2>
                <p>כל חברה בקבוצת לובינסקי מנהלת את מאגריה בנפרד, תחת פיקוח צוות הגנת הפרטיות של הקבוצה.</p>
              </li>

              <li>
                <h2>11. עדכונים למדיניות</h2>
                <p>החברה רשאית לעדכן מדיניות זו מעת לעת. העדכונים יפורסמו באתר וייכנסו לתוקף עם פרסומם.</p>
              </li>
            </ol>
          </div>

        </layout-solid-blob>

    </div>
</template>



<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import {useStore} from "vuex";
import {useMeta} from "vue-meta";
import {useI18n} from "vue-i18n/index";
export default {
    layout    : 'default',
    middleware: {

    },
    setup (props, context) {
        let {meta}                                 = useMeta({title: useI18n().t('talron.privacyPolicy.pageTitle')}).meta

        return {
          meta
        }
    },
    data() {
        return {
            temp : [],
            contactMethods: [

            ],
        }
    },
    components: {

    },
    computed  : {


    },
    methods   : {

    },
    mounted() {

    },

    watch: {},

}
</script>

<style lang="scss" scoped></style>




